// One label, one control, one error message, wired together so a screen reader
// announces the problem instead of leaving it to colour alone.
//
// `subtle` swaps the uppercase label for sentence case: used where two fields sit
// side by side inside an already-labelled block, and a second row of uppercase
// would fight the block's own heading.
export default function Field({ id, label, error, hint, required, subtle, children }) {
  return (
    <div>
      <label
        htmlFor={id}
        className={
          subtle
            ? 'block text-body-s text-ink-2 mb-1.5'
            : 'block text-label font-semibold uppercase text-ink-2 mb-1.5'
        }
      >
        {label}
        {required && <span className="text-alert ml-0.5">*</span>}
      </label>

      {children}

      {hint && !error && <p className="text-body-s text-ink-3 mt-[5px]">{hint}</p>}

      {error && (
        <p id={`${id}-error`} role="alert" className="text-body-s text-alert mt-[5px]">
          {error}
        </p>
      )}
    </div>
  )
}

// The border is the only thing telling a person where to type, so it uses `edge`
// (3.1:1) rather than the decorative `hairline`. Focus turns it brand and lays a
// blush ring behind it; global.css drops the outline here because that border
// change is itself a 17:1 indicator.
export const inputClass = (invalid) =>
  `w-full min-h-[44px] bg-surface border rounded-chip px-3.5 py-2.5 text-body text-ink
   placeholder:text-ink-3 outline-none transition-colors duration-quick ease-out
   focus:shadow-[0_0_0_3px_var(--blush)]
   ${invalid ? 'border-alert focus:border-alert' : 'border-edge focus:border-brand'}`
